module.exports = __webpack_public_path__ + "static/media/icon.31fd41f1.svg";